let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lJJQ8")).then(() => parcelRequire('iDTLl'));